import { FourOhFour } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

function NotFound() {
    const { t } = useTranslation();
    const history = useHistory();

    return <FourOhFour tFunc={t} onLinkClick={() => history.push('/')} />;
}

export default NotFound;
